var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "23px",
    viewBox: "0 0 24 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stream/icon/download/dark",
    transform: "translate(0.000000, -1.000000)",
    fill: "#006A35"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download",
    transform: "translate(2.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5,18.5 L18.5,10 C18.5,9.17157288 19.1715729,8.5 20,8.5 C20.8284271,8.5 21.5,9.17157288 21.5,10 L21.5,20 C21.5,20.8284271 20.8284271,21.5 20,21.5 L0,21.5 C-0.828427125,21.5 -1.5,20.8284271 -1.5,20 L-1.5,10 C-1.5,9.17157288 -0.828427125,8.5 0,8.5 C0.828427125,8.5 1.5,9.17157288 1.5,10 L1.5,18.5 L18.5,18.5 Z",
    id: "Path-2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Arrow",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.31864352,9.14017562 L9.91056358,14.3932393 C10.0513525,14.5542989 10.0228195,14.7893153 9.84683337,14.918163 C9.77447681,14.9711386 9.68457416,15 9.59191255,15 L0.408072427,15 C0.182700249,15 0,14.8327957 0,14.6265387 C0,14.5417363 0.031536144,14.4594589 0.0894213967,14.3932393 L4.68134146,9.14017562 C4.82213034,8.97911599 5.07892721,8.95300306 5.25491331,9.08185077 C5.27844469,9.09907919 5.29981842,9.11864009 5.31864352,9.14017562 Z",
    id: "Triangle",
    transform: "translate(5.000000, 12.000000) scale(1, -1) translate(-5.000000, -12.000000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5,1 C3.5,0.171572875 4.17157288,-0.5 5,-0.5 C5.82842712,-0.5 6.5,0.171572875 6.5,1 L6.5,10 C6.5,10.8284271 5.82842712,11.5 5,11.5 C4.17157288,11.5 3.5,10.8284271 3.5,10 L3.5,1 Z",
    id: "Line-2",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.bd1c668421777fbb2ec2b7f95acb563d.svg";
export { ForwardRef as ReactComponent };